import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page not-found-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title is-1 has-text-centered" }, "Not Found", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle has-text-centered" }, "Sorry, we couldn't find what you were looking for :(", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Go home")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_router_link, {
      class: "button is-link",
      to: "/"
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}